<div class="full_dialog">
    <div class="head_content">
        <h2>Canceling Quotation Request</h2>
        <mat-icon (click)="close()">close</mat-icon>
    </div>
    <div class="content">
        <img src="" alt="">
        <div class="desription">
            <label for="desription">Canceling Raison</label>
            <textarea id="desription"></textarea>
        </div>
    </div>
    <div  class="actions">
        <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
            <span>BACK</span>
        </button>
        <button class="save_btn_pop_up decline">
            <mat-icon color="warn">close</mat-icon>
            <span>CANCEL</span>
        </button>
    </div>
</div>